import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

import { Permission } from '@/constant/permissions';
import { usePermissions } from '@/hooks/usePermissions';
import { isAccountUiVisible } from '@/utils/accountUi';

type ProtectedRouteProps = {
    permissionKeyList: Permission[];
    outlet: JSX.Element;
};

export const PermissionProtectedRoute = ({ permissionKeyList, outlet }: ProtectedRouteProps) => {
  const { userPermissionsLoaded, userCanAll } = usePermissions();

  if (!userPermissionsLoaded) {return null;}

  if (!permissionKeyList.length || userCanAll(permissionKeyList)) {return outlet;}

  return <Navigate to="/403" replace />;
};

export const AnyPermissionProtectedRoute = ({ permissionKeyList, outlet }: ProtectedRouteProps) => {
  const { userPermissionsLoaded, userCanAny } = usePermissions();

  if (!userPermissionsLoaded) {return null;}

  if (!permissionKeyList.length || userCanAny(permissionKeyList)) {
    return outlet;
  }

  return <Navigate to="/403" replace />;
};

type AccountUiProtectedRouteProps = {
    outlet: JSX.Element;
};

/** Account pages, for users who see the account UI; see {@link isAccountUiVisible}. */
export const AccountUiProtectedRoute = ({ outlet }: AccountUiProtectedRouteProps) => {
  // waits only for the login response, so a user with no codes gets /403 rather than a blank page
  const permissionLoaded = useSelector((state: any) => !isEmpty(state.auth.permission));
  const accountUiVisible = useSelector((state: any) => isAccountUiVisible(state.auth.permission));

  if (!permissionLoaded) {return null;}

  if (accountUiVisible) {return outlet;}

  return <Navigate to="/403" replace />;
};
